import React from 'react'

import Input from '@weareroam/cake-ui-v1/Input'
import InputLabel from '@weareroam/cake-ui-v1/InputLabel'
import InputAdornment from '@weareroam/cake-ui-v1/InputAdornment'
import IconButton from '@weareroam/cake-ui-v1/IconButton'
import FormHelperText from '@weareroam/cake-ui-v1/FormHelperText'
import FormControl from '@weareroam/cake-ui-v1/FormControl'
import Visibility from '@weareroam/cake-ui-v1-icons/Visibility'
import VisibilityOff from '@weareroam/cake-ui-v1-icons/VisibilityOff'

import { withStyles } from '@weareroam/cake-ui-v1/styles'
import withRoot from '../withRoot';

import auth from '../utils/auth'
import { navigateTo } from 'gatsby-link'
import storageHelper from '../utils/storageHelper'
import TransitionWrapper from '../components/wrappers/TransitionWrapper'
import LoginButton from '../components/buttons/LoginButton'

const styles = theme => ({
    content: {
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
        backgroundColor: theme.palette.black,
        color: theme.palette.white,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    title: {
        marginBottom: 30,
        ...theme.typography.header.large
    },
    formField: {
        margin: 10,
        display: 'flex',
        flexBasis: 200
    },
    textInput: {
        color: theme.palette.white,
        '&:before': {
            borderBottomColor: theme.palette.white
        },
        '&:hover:before': {
            borderBottomColor: theme.palette.white + '!important'
        }
    },
    inputLabel: {
        color: theme.palette.white
    },
    inputIcon: {
        color: theme.palette.white
    },
    [theme.screens.small]: {
        title: {
            fontSize: 32,
        }
    },
    error: {
        position: 'absolute',
        bottom: -25,
        animation: 'slideDown .3s ease',
        ...theme.typography.error
    }
})

class IndexPage extends React.Component {
    state = {
        password: '',
        showPassword: false,
        error: null
    }

    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value, error: null });
    }

    handleMouseDownPassword = event => {
        event.preventDefault();
    }

    handleClickShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }

    handleIncorrectLogin = () => {
        this.setState({ password: '', error: 'Incorrect password' })
    }

    handleSubmit = (event) => {
        event.preventDefault();
        /*
        Use this code to accept ur invite, replacing the token with your own
        auth.acceptInvite('PUT TOKEN HERE', this.state.password)
        .then(response => {
            console.log(response)
        })
        .catch(error => {
            console.log(error)
        })*/
        auth.login('bobthebuilder@weareroam.com', this.state.password)
        .then(response => {
            const { access_token } = response.token
            storageHelper().addToStorage('accessToken', access_token)
            if (storageHelper().getFromStorage('accessToken')) {
                const { data } = this.props.location

                if (data && data.fromRoot) {
                    this.props.history.goBack()
                } else {
                    navigateTo('/home')
                }
            }
        })
        .catch(error => {
            console.log(JSON.stringify(error))
            if(error.status === 400) {
                this.handleIncorrectLogin()
            }
        })
    }

    render() {

        const { classes } = this.props;

        return (
            <TransitionWrapper root>
                <div className={classes.content}>
                    <div className={classes.block}>
                        <h1 className={classes.title}>What's the word?</h1>
                        <div>
                            <form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
                                <FormControl className={classes.formField} >
                                    <InputLabel htmlFor="adornment-password" className={classes.inputLabel}>Password</InputLabel>
                                    <Input
                                        className={classes.textInput}
                                        id="adornment-password"
                                        type={this.state.showPassword ? 'text' : 'password'}
                                        value={this.state.password}
                                        error={!!this.state.error}
                                        onChange={this.handleChange('password')}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    className={classes.inputIcon}
                                                    aria-label="Toggle password visibility"
                                                    onClick={this.handleClickShowPassword}
                                                    onMouseDown={this.handleMouseDownPassword}
                                                >
                                                    {this.state.showPassword ? <Visibility/> : <VisibilityOff/>}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                {this.state.error && (
                                    <FormHelperText classes={{root: classes.error}}>{this.state.error}</FormHelperText>
                                )}
                                </FormControl>
                                <LoginButton />
                            </form>
                        </div>
                    </div>
                </div>
            </TransitionWrapper>
        )
    }
}

export default withRoot(withStyles(styles)(IndexPage))



// WEBPACK FOOTER //
// ./src/pages/index.js